import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
export function CountdownPricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 22,
    minutes: 59,
    seconds: 10
  });
  const [selectedPack, setSelectedPack] = useState<'basico' | 'completo'>('completo');
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };else if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };else if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const packs = {
    basico: {
      url: 'https://pagos.recursosfitness.shop/cart/44006466322529:1',
      buttonText: 'SÍ, QUIERO FÚTBOL FEMENINO RESUELTO →'
    },
    completo: {
      url: 'https://pagos.recursosfitness.shop/cart/44006482411617:1',
      buttonText: 'SÍ, QUIERO MI PACK COMPLETO →'
    }
  };
  return <section id="pricing" className="py-6 md:py-10 px-4 bg-navy-dark text-white" data-id="element-49">
      <div className="max-w-2xl mx-auto" data-id="element-50">
        {/* Countdown Header - compact */}
        <div className="text-center mb-4 md:mb-6" data-id="element-51">
          <h2 className="text-base md:text-xl font-black text-white mb-3" data-id="element-52">
            EL PRECIO DE LANZAMIENTO TERMINA EN:
          </h2>

          <div className="flex justify-center gap-2 md:gap-3 mb-3" data-id="element-53">
            {[{
            label: 'HRS',
            value: timeLeft.hours
          }, {
            label: 'MIN',
            value: timeLeft.minutes
          }, {
            label: 'SEG',
            value: timeLeft.seconds
          }].map((item, i) => <Fragment key={i} data-id="element-54">
                <motion.div animate={{
              scale: [1, 1.04, 1]
            }} transition={{
              repeat: Infinity,
              duration: 2
            }} className="bg-navy border border-white/10 w-14 h-14 md:w-18 md:h-18 rounded-lg flex flex-col items-center justify-center" data-id="element-55">
                  <span className="text-xl md:text-3xl font-black leading-none" data-id="element-56">
                    {item.value.toString().padStart(2, '0')}
                  </span>
                  <span className="text-[9px] md:text-xs font-bold text-brandGreen" data-id="element-57">
                    {item.label}
                  </span>
                </motion.div>
                {i < 2 && <div className="text-xl md:text-3xl font-black text-white/40 self-center" data-id="element-58">
                    :
                  </div>}
              </Fragment>)}
          </div>

          <p className="text-sm md:text-base font-bold text-red-500 mb-3" data-id="element-59">
            Después sube $8.000 ARS y no vuelve a bajar.
          </p>

          <div className="max-w-sm mx-auto bg-navy p-2.5 rounded-lg border border-white/10" data-id="element-60">
            <div className="flex justify-between text-[10px] md:text-xs font-bold text-gray-400 mb-1.5" data-id="element-61">
              <span data-id="element-62">Cupos al precio de lanzamiento</span>
              <span data-id="element-63">68% tomados</span>
            </div>
            <div className="w-full bg-white/10 rounded-full h-1.5 md:h-2 overflow-hidden" data-id="element-64">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '68%'
            }} viewport={{
              once: true
            }} transition={{
              duration: 1,
              ease: 'easeOut'
            }} className="bg-brandGreen h-full rounded-full" data-id="element-65" />
            </div>
          </div>
        </div>

        {/* Section title - compact */}
        <div className="text-center mb-3 md:mb-4" data-id="element-66">
          <h3 className="text-lg md:text-2xl font-black text-white" data-id="element-67">
            Elegí tu Fútbol Femenino Resuelto:
          </h3>
          <p className="text-xs md:text-sm text-gray-400 font-medium mt-1" data-id="element-68">
            Las dos opciones incluyen los 6 bonos estratégicos completos
          </p>
        </div>

        {/* Pricing Options - compact */}
        <div className="flex flex-col gap-2.5 mb-4" data-id="element-69">
          {/* Option 1: Básico */}
          <div onClick={() => setSelectedPack('basico')} className={`rounded-xl p-3.5 md:p-4 cursor-pointer transition-all border-2 flex items-center gap-3 ${selectedPack === 'basico' ? 'border-brandGreen bg-navy shadow-[0_0_15px_rgba(34,197,94,0.15)]' : 'border-white/10 bg-navy-dark hover:border-white/20'}`} data-id="element-70">
            <div className="flex-shrink-0" data-id="element-71">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPack === 'basico' ? 'border-brandGreen' : 'border-gray-500'}`} data-id="element-72">
                {selectedPack === 'basico' && <div className="w-2.5 h-2.5 rounded-full bg-brandGreen" data-id="element-73" />}
              </div>
            </div>
            <div className="flex-1 flex items-center justify-between gap-2" data-id="element-74">
              <div data-id="element-75">
                <h4 className="text-sm md:text-base font-black text-white flex items-center gap-1.5" data-id="element-76">
                  📘 FÚTBOL FEMENINO RESUELTO
                </h4>
                <p className="text-xs text-gray-400" data-id="element-77">6 Tomos + 6 Bonos</p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-78">
                <div className="text-gray-500 line-through text-xs font-bold" data-id="element-79">
                  $27.990
                </div>
                <div className="text-2xl md:text-3xl font-black text-white" data-id="element-80">
                  $19.990
                </div>
              </div>
            </div>
          </div>

          {/* Option 2: Completo */}
          <div onClick={() => setSelectedPack('completo')} className={`rounded-xl p-3.5 md:p-4 cursor-pointer transition-all border-2 flex items-center gap-3 ${selectedPack === 'completo' ? 'border-brandGreen bg-navy shadow-[0_0_15px_rgba(34,197,94,0.2)]' : 'border-white/10 bg-navy-dark hover:border-white/20'}`} data-id="element-81">
            <div className="flex-shrink-0" data-id="element-82">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPack === 'completo' ? 'border-brandGreen' : 'border-gray-500'}`} data-id="element-83">
                {selectedPack === 'completo' && <div className="w-2.5 h-2.5 rounded-full bg-brandGreen" data-id="element-84" />}
              </div>
            </div>
            <div className="flex-1 flex items-center justify-between gap-2" data-id="element-85">
              <div data-id="element-86">
                <h4 className="text-sm md:text-base font-black text-white flex items-center gap-1.5" data-id="element-87">
                  🏆 PACK COMPLETO
                </h4>
                <div className="flex flex-wrap gap-1.5 mt-1 mb-1" data-id="element-88">
                  <span className="bg-brandGreen text-navy text-[9px] md:text-[10px] font-bold px-1.5 py-0.5 rounded-sm flex items-center gap-0.5" data-id="element-89">
                    ⭐ MÁS ELEGIDO
                  </span>
                  <span className="bg-brandGreen/10 text-brandGreen border border-brandGreen/30 text-[9px] md:text-[10px] font-bold px-1.5 py-0.5 rounded-sm" data-id="element-90">
                    AHORRÁS $16.000
                  </span>
                </div>
                <p className="text-xs text-gray-400 leading-snug" data-id="element-91">
                  6 Tomos + 6 Bonos +{' '}
                  <span className="text-gray-300" data-id="element-92">Megapack Porteras™</span> +{' '}
                  <span className="text-gray-300" data-id="element-93">
                    Academia del Entrenador™
                  </span>
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-94">
                <div className="text-gray-500 line-through text-xs font-bold" data-id="element-95">
                  $43.990
                </div>
                <div className={`text-2xl md:text-3xl font-black ${selectedPack === 'completo' ? 'text-brandGreen' : 'text-white'}`} data-id="element-96">
                  $27.990
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Button - compact */}
        <div className="mb-4" data-id="element-97">
          <a href={packs[selectedPack].url} className="block w-full bg-brandGreen hover:bg-brandGreen-hover text-navy font-black text-base md:text-lg py-3.5 md:py-4 rounded-xl text-center transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_20px_rgba(34,197,94,0.3)]" data-id="element-98">
            {packs[selectedPack].buttonText}
          </a>
          <p className="text-center text-gray-500 text-xs mt-2 italic" data-id="element-99">
            La opción más elegida por entrenadores de fútbol femenino
          </p>
        </div>

        {/* Trust Badges - compact */}
        <div className="flex flex-wrap justify-center items-center gap-3 md:gap-5 text-[10px] md:text-xs font-medium text-gray-400 bg-navy py-2.5 px-4 rounded-lg border border-white/10" data-id="element-100">
          <span className="flex items-center gap-1.5" data-id="element-101">
            <Lock className="w-3.5 h-3.5 text-brandGreen" data-id="element-102" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-103">
            <Zap className="w-3.5 h-3.5 text-brandGreen" data-id="element-104" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-1.5" data-id="element-105">
            <ShieldCheck className="w-3.5 h-3.5 text-brandGreen" data-id="element-106" /> Garantía 7
            días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-107">
            <CreditCard className="w-3.5 h-3.5 text-brandGreen" data-id="element-108" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}